var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mobile',{attrs:{"max_price":_vm.max_price,"min_price":_vm.min_price,"get_filter":_vm.get_filter},on:{"change":_vm.change}}),_vm._v(" "),_c('desktop',{attrs:{"categories":_vm.categories,"title":_vm.title,"max_price":_vm.max_price,"min_price":_vm.min_price,"get_filter":_vm.get_filter},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }